import '../../styles/ButtonComponent.css';

import Button from '@mui/material/Button';
import { ButtonComponent } from '../../models/LessonComponent';
import { LessonContextConsumer } from '../../../content/models/LessonContext';
import React from 'react';
import { WithCaption } from './WithCaption';

interface ButtonComponentProps {
  component: ButtonComponent;
}

export function ButtonComponentView(props: ButtonComponentProps) {
  return (
    <LessonContextConsumer>
      {({ mode }) => (
        <WithCaption {...props}>
          <div className="button-alignment">
            <Button
              color="primary"
              variant="contained"
              disabled={mode === 'edit'}
              href={props.component.settings.link}
              target="_blank"
            >
              {props.component.settings.buttonLabel}
            </Button>
          </div>
        </WithCaption>
      )}
    </LessonContextConsumer>
  );
}
